// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React, {useEffect, useRef, useCallback, useState} from 'react';
import cn from 'classnames';
import {Text} from '@pub/comp/text';
import {Icon} from '@pub/comp/icon';
import {Button} from '@pub/comp/button';
import * as cns from './input.module.less';

const get_sizes = size=>{
    return {
        s: {icon: 'xxs', text: 'xxs', btn: 's'},
        m: {icon: 'xs', text: 'xs', btn: 'm'},
        l: {icon: 's', text: 's', btn: 'l'},
    }[size];
};

export function Input({
    className,
    id,
    on_change,
    on_blur,
    on_focus,
    on_enter,
    on_esc,
    placeholder,
    autocomplete,
    value,
    type,
    rows,
    name,
    disabled,
    read_only,
    auto_focus,
    error,
    ico,
    size='m',
    is_mono_font=false,
})
{
    const is_pass = type=='password';
    const [show_pass, set_show_pass] = useState(false);
    const toggle_show_pass = useCallback(()=>set_show_pass(v=>!v), []);
    const input_ref = useRef();
    useEffect(()=>{
        if (auto_focus)
            requestAnimationFrame(()=>input_ref?.current?.focus());
    }, [auto_focus]);
    const handle_change = useCallback(event=>{
        on_change?.(event.target.value);
    }, [on_change]);
    const handle_key_up = useCallback(event=>{
        if (event.key=='Enter')
            on_enter?.();
        if (event.key=='Escape')
            on_esc?.();
    }, [on_enter, on_esc]);
    const {icon: i_size, btn: b_size} = get_sizes(size);
    const classes = cn(cns.root, cns[`root__size_${size}`], {
        [cns.root__disabled]: disabled,
        [cns.root__pass]: is_pass,
        [cns.root__mono]: is_mono_font,
    }, className);
    const input_type = is_pass
        ? show_pass ? 'text' : 'password'
        : type;
    const Comp = type=='textarea' ? 'textarea' : 'input';
    return <div className={classes}>
      {!!ico&&<Icon className={cns.icon} name={ico} size={i_size}
        color="main"/>}
      <Comp className={cns.input} ref={input_ref} id={id} value={value}
        name={name} onChange={handle_change} placeholder={placeholder}
        type={input_type} disabled={disabled} readOnly={read_only}
        onBlur={on_blur} onFocus={on_focus} autoComplete={autocomplete}
        onKeyUp={handle_key_up} rows={rows}/>
      {is_pass&&<Button className={cns.toggle_pass} view="link"
        on_click={toggle_show_pass} color_scheme="main"
        ico={show_pass ? 'ico_hide' : 'ico_show'} size={b_size}
        tooltip_text={show_pass ? 'Hide password' : 'Show password'}/>}
      {error&&<Text.xxs className={cns.error} error>{error}</Text.xxs>}
    </div>;
}
